const getOrderLineRefill = ({ orderLine, value, index, showUnits = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Refill) {
      return showUnits ? `${indexOrderLine.Refill} months` : indexOrderLine.Refill;
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => (showUnits ? `${item.Refill} months` : item.Refill)).join(', ')
    : null;
};

export default getOrderLineRefill;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineRefill.js